import styled from "styled-components";
import { SolutionColorVariables, TextColorNames } from "@smartsuite/types";

export const StyledTopLineOuter = styled.div`
  margin-bottom: 8px;
`;

export const StyledTopLineHead = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTitle = styled.div<{
  largeCaption?: boolean;
  open?: boolean;
}>`
  font-family: inherit;
  font-size: ${(props) => (props?.largeCaption ? "18px" : "14px")};
  line-height: ${(props) => (props?.largeCaption ? "25px" : "18px")};
  font-weight: 500;
  display: inline-block;
  color: ${(props) =>
    props?.open === true ? SolutionColorVariables.sc1 : TextColorNames.primary};
`;

export const StyledHelpText = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: ${TextColorNames.secondary};

  b {
    color: ${TextColorNames.primary};
  }

  a {
    color: ${TextColorNames.secondary};
  }
`;

export const StyledIcon = styled.span`
  position: relative;
  display: inline-flex;
  margin: 0 8px 0 0;
`;

export const StyledTopLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TrashIconWrapper = styled.div`
  padding-right: 7px;
  padding-top: 3px;
  visibility: hidden;
  cursor: pointer;
`;

export const StyledRightOptions = styled.div`
  display: flex;
  align-content: center;
`;

export const StyledTooltipWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  vertical-align: middle;
`;

export const StyledParseValues = styled.div`
  z-index: 1;
  opacity: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 0px;
  transition: width 350ms ease-in-out, opacity 280ms linear;
  cursor: pointer;
`;

export const StyledCreateNewValues = styled.div`
  z-index: 1;
  opacity: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 0px;
  transition: width 350ms ease-in-out, opacity 280ms linear;
  cursor: pointer;
`;

export const StyledRemoveButton = styled.div`
  z-index: 2;
  opacity: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 0px;
  transition: width 350ms ease-in-out, opacity 280ms linear;
  cursor: pointer;
`;

export const StyledOptionLabel = styled.span`
  fontsize: 13px;
  // color: #b2b2b3;
  fontweight: 500;
`;
